import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import axios from "axios";
import { NavLink } from "react-bootstrap";
import { saveAs } from 'file-saver';
import { Parser } from 'json2csv';

const BloodZoneList = () => {
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const history = useHistory();
  const token = localStorage.getItem('authToken');

  const getData = async () => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin//blooddonor`, {
        params: {
          page: currentPage,
          search: searchQuery
        }
      }, {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
      setUsers(response?.data?.data?.users);
      setTotalPages(response?.data?.data?.totalPages);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, [currentPage, searchQuery]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to the first page on new search
  };

  
  const handleDownload = () => {
    const fields = [

        "id", "fullName", "contactNo", "bloodGroup", "pincode", "address",
       "createdAt"
    ]
    const json2csvParser = new Parser({ fields });
    const csv = json2csvParser.parse(users);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'blood_donor.csv');

}

const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
};


  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>Blood Donor List</h2>
        </div>
        <div className="d-flex justify-content-start">
          <div className="input-group m-b-10 col-lg-3">
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="icon-magnifier"></i>
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder="Search By Full Name"
              value={searchQuery}
              onChange={handleSearch}
            />
          </div>
          <div>
          <button className="btn btn-primary" onClick={handleDownload}>Download CSV</button>
          </div>
        </div>
        <div className="body table-responsive">
          <table className="table table-hover">
            <thead style={{textAlign:"center"}}>
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Contact</th>
                <th>Address</th>
                <th>Blood Group</th>
                <th>Pincode</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody  style={{textAlign:"center"}}>
              {users.map((user, index) => (
                <tr key={user.id}>
                  <td>{(currentPage - 1) * 10 + index + 1}</td>
                  <td>{user.fullName}</td>
                  <td>{user.contactNo}</td>
                  <td>{user.address}</td>
                  <td>{user.bloodGroup}</td>
                  <td>{user.pincode}</td>
                  <td> {formatDate(user.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="body">
          <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
            <ul className="pagination">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </NavLink>
              </li>
              {[...Array(totalPages).keys()].map(page => (
                <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                  <NavLink
                    to="#"
                    className="page-link"
                    onClick={() => handlePageChange(page + 1)}
                  >
                    {page + 1}
                  </NavLink>
                </li>
              ))}
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default BloodZoneList;
